import { render, staticRenderFns } from "./MatrizIperc.vue?vue&type=template&id=211a1d2a&scoped=true"
import script from "./MatrizIperc.vue?vue&type=script&lang=js"
export * from "./MatrizIperc.vue?vue&type=script&lang=js"
import style0 from "./MatrizIperc.vue?vue&type=style&index=0&id=211a1d2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211a1d2a",
  null
  
)

export default component.exports